<template>
  <div
    class="fuel-consumption-vessel-card px-2 py-4 flex items-center justify-between cursor-pointer"
    v-on:mouseover="mouseOver"
    v-on:mouseleave="mouseLeave"
    @click="clickVoyageButton()"
  >
    <div class="flex items-center">
      <!-- 船舶画像 -->
      <div
        ref="PicturesViewContainer"
        class="vs-con-loading__container mr-4 image-view no-pictures-view w-full h-full"
        :id="pictureViewId"
      >
        <div v-show="!hasPicture" class="">
          {{ pictureText }}
        </div>
        <div
          v-show="hasPicture && showPicture"
          class="image-view pictures-view w-full h-full"
        >
          <img :src="pictureSrc" />
        </div>
      </div>

      <div class="vessel-name-text">
        {{ vessel.name }}
      </div>
    </div>
    <div v-show="hovered" class="flex items-center">
      <div class="card-button" @click.stop="clickVoyageButton()">
        <vx-tooltip text="航海ごとのレポート">
          <img :src="voyageButtonIconSrc" />
        </vx-tooltip>
      </div>

      <!-- メニュー群 -->
      <div class="card-button" @click.stop="clickPeriodButton()">
        <vx-tooltip text="月・年次のレポート">
          <img :src="periodButtonIconSrc" />
        </vx-tooltip>
      </div>
      <div class="card-button" @click.stop="clickExportButton()">
        <vx-tooltip text="CSVダウンロード">
          <img :src="exportButtonIconSrc" />
        </vx-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    vessel: {
      type: Object,
      required: true,
    },
    clickVoyageFunc: {
      type: Function,
      required: true,
    },
    clickPeriodFunc: {
      type: Function,
      required: true,
    },
    clickExportFunc: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      hovered: false,
      pictureSrc: "",
      periodButtonIconSrc: require("@/assets/images/fuel-consumption/icon/calendar.svg"),
      exportButtonIconSrc: require("@/assets/images/fuel-consumption/icon/document.svg"),
      voyageButtonIconSrc: require("@/assets/images/fuel-consumption/icon/graph.svg"),
      showPicture: false,
    };
  },
  computed: {
    hasPicture() {
      return this.vessel.pictures.length > 0;
    },
    pictureText() {
      return "No image";
    },
    pictureViewId() {
      return `picture-view-${this.vessel.id}-container`;
    },
  },
  methods: {
    mouseOver() {
      this.hovered = true;
    },
    mouseLeave() {
      this.hovered = false;
    },
    async initPicture() {
      if (!this.hasPicture) return;
      this.openLoadingView();
      const path = this.vessel.pictures[0].thumbnail_path;
      const url = await storage.child(path).getDownloadURL();
      this.pictureSrc = url;
      this.showPicture = true;
      this.closeLoadingView();
    },
    clickVoyageButton() {
      this.clickVoyageFunc(this.vessel);
    },
    clickPeriodButton() {
      this.clickPeriodFunc(this.vessel.id);
    },
    clickExportButton() {
      this.clickExportFunc(this.vessel);
    },
    openLoadingView() {
      this.$vs.loading({
        container: `#${this.pictureViewId}`,
        scale: 0.6,
      });
    },
    closeLoadingView() {
      setTimeout(() => {
        this.$vs.loading.close(`#${this.pictureViewId} > .con-vs-loading`);
      }, 200);
    },
  },
  mounted() {
    this.initPicture();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "src/assets/scss/aisea/fuel-consumption";

.fuel-consumption-vessel-card {
  &:hover {
    background-color: $aisea-white;
  }

  .image-view {
    display: block;
    width: 96px;
    height: 64px;
  }

  .card-button {
    @extend .button;

    &__disabled {
      @extend .button;
      cursor: default;

      &:hover {
        background-color: transparent;
      }
    }
  }

  .no-pictures-view {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $aisea-pure-white;
    background-color: $aisea-black;
    border-radius: 6px;
  }

  .pictures-view {
    background-color: $aisea-black;
    border-radius: 6px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }

  .vessel-name-text {
    font-size: 16px;
    word-break: break-all;
  }
}
</style>
